import { PaysafeFormField } from '../models/paysafe/paysafe-form-field.enum';
import { PaysafeSetupOptions } from '../models/paysafe/paysafe-setup-options.interface';

export const defaultPaysafeSetupOptions: PaysafeSetupOptions = {
  fields: {
    cardNumber: {
      accessibilityLabel: 'Card number',
      fieldName: PaysafeFormField.CardNumber,
      placeholder: '4111 1111 1111 11111',
      selector: '#cardNumber',
      separator: ' ',
    },
    cvv: {
      accessibilityLabel: 'CVV',
      fieldName: PaysafeFormField.Cvv,
      mask: false,
      placeholder: '123',
      selector: '#cvv',
    },
    expiryDate: {
      accessibilityLabel: 'Expiry date',
      selector: '#expiryDate',
      fieldName: PaysafeFormField.ExpiryDate,
      placeholder: 'MM/YY',
    },
  },
  style: {
    input: {
      'font-family': '"Source Sans Pro", Arial, sans-serif',
      'font-size': '16px',
      'font-weight': '500',
      'line-height': '24px',
      'letter-spacing': '0.2px',
    },
  },
};
